<template>
  <div>
    <el-main>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
        <el-breadcrumb-item class="item_font"> 系统参数配置</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 常规设置 -->
      <el-table
        :data="configList"
        style="width: 100%"
        stripe
        :cell-style="cellStyle"
      >
        <el-table-column width="600">
          <template slot-scope="scope">
            <div v-if="scope.row.confKey === 'FILTER_IP_AFTER_OPENING'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>

              <div>
                <span>{{ scope.row.confVal }}</span>
              </div>
            </div>
            <div v-if="scope.row.confKey === 'FILTER_WORDS_AFTER_OPENING'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>

              <div>
                <span>{{ scope.row.confVal }}</span>
              </div>
            </div>
            <div v-if="scope.row.confKey === 'HIDE_SCRIPT_SWITCH'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>
            </div>
            <div v-if="scope.row.confKey === 'DISEASE_KEYWORD_DIST_FLAG'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>
            </div>
            <div v-if="scope.row.confKey === 'PICTURE_SWITCH'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>
            </div>
            <div v-if="scope.row.confKey === 'PICTURE_URL'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>

              <el-image
                style="width: 200px; height: 200px"
                :src="scope.row.confVal"
                :preview-src-list="[scope.row.confVal]"
                fit="contain"
              >
              </el-image>
              <!-- <img
                style="width: 200px; height: 200px"
                :src="scope.row.confVal"
              /> -->
            </div>

            <div v-if="scope.row.confKey === 'SYS_NEW_CUSTOMER_INVITATION'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>

              <div>
                <span>{{ scope.row.confVal }}</span>
              </div>
            </div>
            <div v-if="scope.row.confKey === 'SYS_OLD_CUSTOMER_INVITATION'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>

              <div>
                <span>{{ scope.row.confVal }}</span>
              </div>
            </div>

            <div v-if="scope.row.confKey === 'MESSAGE_REMINDER_COLOR'">
              <div class="column1">
                <span style="margin-left: 6px">{{
                  scope.row.confExplain
                }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="scope.row.confKey === 'FILTER_IP_AFTER_OPENING'"
              style="
                background-color: #1577d2;
                margin-right: 10px;
                letter-spacing: 1px;
              "
              size="mini"
              @click="showDialog(scope.row)"
              >编辑过滤ip</el-button
            >
            <el-button
              type="primary"
              v-if="scope.row.confKey === 'FILTER_WORDS_AFTER_OPENING'"
              style="
                background-color: #1577d2;
                margin-right: 10px;
                letter-spacing: 1px;
              "
              size="mini"
              @click="showDialog(scope.row)"
              >编辑过滤词</el-button
            >
            <!-- <div
              v-if="scope.row.confKey === 'HIDE_SCRIPT_SWITCH'"
              style="margin-right: 10px"
            >
              on -->
            <el-switch
              v-model="formData.guideSwitch"
              active-color="#13ce66"
              inactive-color="#bfbfbf"
              active-text="开启"
              inactive-text="关闭"
              style="letter-spacing: 1px; margin-right: 10px"
              v-if="scope.row.confKey === 'HIDE_SCRIPT_SWITCH'"
              @change="onOff(scope.row)"
            ></el-switch>
            <!-- off
            </div> -->

            <el-switch
              v-model="formData.diseaseSwitch"
              active-color="#13ce66"
              inactive-color="#bfbfbf"
              active-text="开启"
              inactive-text="关闭"
              style="letter-spacing: 1px; margin-right: 10px"
              v-if="scope.row.confKey === 'DISEASE_KEYWORD_DIST_FLAG'"
              @change="onOff(scope.row)"
            ></el-switch>

            <el-button
              type="primary"
              v-if="scope.row.confKey === 'SYS_NEW_CUSTOMER_INVITATION'"
              style="
                background-color: #1577d2;
                margin-right: 10px;
                letter-spacing: 1px;
              "
              size="mini"
              @click="showDialog(scope.row)"
              >修改新用户邀请语</el-button
            >
            <el-button
              type="primary"
              v-if="scope.row.confKey === 'SYS_OLD_CUSTOMER_INVITATION'"
              style="
                background-color: #1577d2;
                margin-right: 10px;
                letter-spacing: 1px;
              "
              size="mini"
              @click="showDialog(scope.row)"
              >修改老用户邀请语</el-button
            >
            <el-switch
              v-model="formData.imageSwitch"
              active-color="#13ce66"
              inactive-color="#bfbfbf"
              active-text="开启"
              inactive-text="关闭"
              style="margin-right: 10px; letter-spacing: 1px"
              v-if="scope.row.confKey === 'PICTURE_SWITCH'"
              @change="onOff(scope.row)"
            ></el-switch>

            <el-upload
              class="upload-demo"
              v-if="scope.row.confKey === 'PICTURE_URL'"
              :action="uploadImageUrl"
              :show-file-list="false"
              :on-success="uploadImageUrlSuccess"
            >
              <el-button
                type="primary"
                style="
                  background-color: #1577d2;
                  margin-right: 10px;
                  letter-spacing: 1px;
                "
                size="mini"
                >更新系统图片话术</el-button
              >
              <!-- <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div> -->
            </el-upload>
            <!-- <el-button
              type="primary"
              v-if="scope.row.confKey === 'PICTURE_URL'"
              style="
                background-color: #1577d2;
                margin-right: 10px;
                letter-spacing: 1px;
              "
              size="mini"
              @click="showUploadDialog(scope.row)"
              >更新系统图片话术</el-button
            > -->
            <div v-if="scope.row.confKey === 'MESSAGE_REMINDER_COLOR'" style="display: flex;align-items: center;justify-content: space-between;">
              <div
                :style="{
                  width: '16px',
                  height: '16px',
                  backgroundColor: scope.row.confVal,
                }"
              ></div>
              <el-color-picker
                v-model="color"
                :show-alpha="false"
                :predefine="predefineColors"
                @change="selectChange"
              >
              </el-color-picker>

            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <!-- 编辑文本 -->
    <el-dialog
      width="600px"
      lock-scroll
      :visible.sync="edit_show"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <span class="el-dialog__title">{{ editTitle }}</span>
      </template>
      <span class="el-dialog__sub" v-if="editTipText">{{ editTipText }}</span>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="请输入内容"
        v-model="editObj.confVal"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_show = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          size="mini"
          style="background-color: #1577d2"
          @click="trueEdit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      configList: [],
      edit_show: false,
      // 编辑标题
      editTitle: "",
      // 弹窗提示文本
      editTipText: "",
      // 弹窗的响应式数据对象
      editObj: {},
      formData: {
        guideSwitch: false,
        imageSwitch: false,
        diseaseSwitch: false,
        filterIps: "",
        filterWords: "",
        newUserInvitation: "",
        oldUserInvitation: "",
      },
      color:'',
      predefineColors: [
        "#FF6666",
        "#B05DC9",
        "#FAAD14",
        "#AB7762",
        "#5A9CF8",
        "#62AB76",
      ],
      uploadImageUrl:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/fileInfo/pass/uploadPicture",
    };
  },
  mounted() {
    this.getConfigList();
  },
  methods: {
    // 获取权限列表
    async getConfigList() {
      const api = "/manager/sysconf/listSystemParams";
      const res = await this.util.postRequest({
        url: api,
        method: "GET",
      });
      console.log("ConfigParams.vue getConfigList res = ", res);
      if (res.resultCode !== "10000") {
        this.$message.error(res.desc);
      } else {
        this.configList = res.data ? res.data : [];
        for (let i = 0; i < this.configList.length; i++) {
          const item = this.configList[i];

          switch (item.confKey) {
            case "PICTURE_SWITCH": {
              this.formData.imageSwitch = item.confVal === "on";
              break;
            }
            case "HIDE_SCRIPT_SWITCH": {
              this.formData.guideSwitch = item.confVal === "on";
              break;
            }

            case "DISEASE_KEYWORD_DIST_FLAG": {
              this.formData.diseaseSwitch = item.confVal === "on";
              break;
            }

            case "MESSAGE_REMINDER_COLOR": {
              this.color = item.confVal;
              break;
            }
            // case "FILTER_IP_AFTER_OPENING": {
            //   this.formData.filterIps = JSON.parse(
            //     JSON.stringify(item.confVal)
            //   );
            //   break;
            // }
            // case "FILTER_WORDS_AFTER_OPENING": {
            //   this.formData.filterWords = JSON.parse(
            //     JSON.stringify(item.confVal)
            //   );
            //   break;
            // }
            // case "SYS_NEW_CUSTOMER_INVITATION": {
            //   this.formData.newUserInvitation = JSON.parse(
            //     JSON.stringify(item.confVal)
            //   );
            //   break;
            // }
            // case "SYS_OLD_CUSTOMER_INVITATION": {
            //   this.formData.oldUserInvitation = JSON.parse(
            //     JSON.stringify(item.confVal)
            //   );
            //   break;
            // }
            default:
              () => {};
          }
        }
      }
    },

    async selectChange(value) {
      console.log(value);

      const obj = {
        confKey: "MESSAGE_REMINDER_COLOR",
        confVal: value,
        hideStatus: 1,
      };
      this.upDateConfigList(obj);
    },

    // 更新图片话术

    async uploadImageUrlSuccess(res) {
      if (res.resultCode === "10000") {
        this.$message.success("系统图片话术更新成功！");
        this.getConfigList();
      } else {
        this.$message.error(res.desc);
      }
    },

    cellStyle({ columnIndex }) {
      if (columnIndex === 1) {
        return "text-align:right";
      }
    },

    // 更新权限列表
    async upDateConfigList(item) {
      const api = "/manager/sysconf/updateSystemParams";
      const res = await this.util.postRequest({
        url: api,
        data: [
          {
            confKey: item.confKey,
            confVal: item.confVal,
            hideStatus: item.hideStatus,
          },
        ],
        method: "POST",
      });
      console.log("ConfigParams.vue getConfigList res = ", res);
      if (res.resultCode !== "10000") {
        this.$message.error(res.desc);
      } else {
        this.$message.success("修改成功！");
        this.getConfigList();
      }
    },

    // 引导语开关
    onOff(item) {
      let val = null;
      switch (item.confKey) {
        case "PICTURE_SWITCH": {
          val = this.formData.imageSwitch;
          break;
        }
        case "HIDE_SCRIPT_SWITCH": {
          val = this.formData.guideSwitch;
          break;
        }

        case "DISEASE_KEYWORD_DIST_FLAG": {
          val = this.formData.diseaseSwitch;
          break;
        }

        default:
          () => {};
      }
      const obj = {
        confKey: item.confKey,
        confVal: val ? "on" : "off",
        hideStatus: item.hideStatus,
      };
      this.upDateConfigList(obj);
    },

    showDialog(item) {
      this.edit_show = true;
      this.editTipText = item.confExplain;
      this.editObj = JSON.parse(JSON.stringify(item));
      switch (item.confKey) {
        case "FILTER_IP_AFTER_OPENING": {
          // this.editObj.confVal = item.confVal.replace("；", " ");
          this.editTitle = "编辑过滤IP";
          // this.editObj.confVal = this.formData.filterIps;
          break;
        }
        case "FILTER_WORDS_AFTER_OPENING": {
          // this.editObj.confVal = item.confVal.replace("；", " ");
          this.editTitle = "编辑过滤词";
          // this.editObj.confVal = this.formData.filterWords;
          break;
        }
        case "SYS_NEW_CUSTOMER_INVITATION": {
          this.editTitle = "编辑新用户邀请语";
          // this.editObj.confVal = this.formData.newUserInvitation;
          break;
        }
        case "SYS_OLD_CUSTOMER_INVITATION": {
          this.editTitle = "系统老客户邀请语";
          // this.editObj.confVal = this.formData.oldUserInvitation;
          break;
        }

        default:
          () => {};
      }
    },
    async trueEdit() {
      await this.upDateConfigList(this.editObj);
      this.edit_show = false;
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
.column1 {
  // background-color: red;
  display: flex;
  align-items: center;
  &::before {
    content: "";
    display: block;
    width: 3px;
    height: 1em;
    background-color: #1577d2;
  }
  p {
    text-indent: 2em;
  }
}

::v-deep .el-dialog {
  .el-dialog__title {
    display: flex;
    color: #333;
    font-weight: 600;
    line-height: 1;
  }
  .el-dialog__title::before {
    display: block;
    content: "";
    width: 3px;
    height: auto;
    background-color: #1577d2;
    margin-right: 6px;
  }
  .el-dialog__sub {
    color: #999;
  }
  .el-dialog__body {
    padding: 2px 20px 10px;
  }
  .el-textarea {
    margin-top: 12px;
  }
}
</style>
